<template>
  <div class="qx-button-group">
    <div class="d-flex">
      <button
        class="v-btn button-content"
        :class="[`btn-${state}`, { 'custom-height': isTableAction, 'fileinput-button': isFileInput }]"
        :disabled="disabled">
        <slot
          name="button-content"
          @click="!disabled && action" />
      </button>
      <v-btn
        id="menu-activator"
        :disabled="disabled"
        class="dropdown-toggle btn-link"
        :class="[`btn-${state}`, { 'custom-height': isTableAction }]">
        <em class="qx-icon icon-arrow-down-sm" />
      </v-btn>
    </div>
    <v-menu
      :id="`${id}-button`"
      activator="#menu-activator"
      transition="fade-transition"
      :text="title"
      :variant="state"
      :split="Boolean(items.length)"
      :disabled="disabled"
      @click="action">
      <v-list
        v-if="items.length"
        class="dropdown-menu">
        <v-list-item
          v-for="(item, index) in items"
          :key="item.id"
          :value="index">
          <v-list-item-title
            :class="[`${item.id}-action`, item.class ? item.class : '']"
            :type="item.type || 'button'"
            @click.stop="onClick(item.action, $event)">
            <slot
              :name="`${item.id}-label`"
              :item="item"
              :data="itemsActionData">
              <em
                v-if="item.icon"
                :class="item.icon" />
              {{ item.title }}
            </slot>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'QxButtonGroup',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => {},
    },
    state: {
      type: String,
      default: 'custom-blue',
      validator: (value) => {
        return ['custom-orange', 'link', 'custom-blue', 'border-info-blue'].includes(value);
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemsActionData: {
      type: [String, Number, Object, Array],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTableAction: {
      type: Boolean,
      default: false,
    },
    isFileInput: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClick(action, event) {
      action(this.itemsActionData, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.qx-button-group {
  @import '@/assets/scss/_buttons.scss';

  .v-btn {
    padding: 0 3px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    opacity: 1 !important;
    &.btn-custom-blue {
      border: none;
    }
    &.dropdown-toggle {
      border-left: none;
    }
    &.custom-height {
      height: 35px;
      :deep .qx-icon {
        font-size: 21px;
        padding-right: 3px;
      }
    }
  }
  .button-content {
    padding: 0 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 4px;
    cursor: pointer;
    input {
      cursor: pointer;
    }
    &::after {
      cursor: pointer;
    }
  }
  .dropdown-toggle {
    text-decoration: none;
    &::after {
      vertical-align: middle;
    }
  }
}
.v-menu > .v-overlay__content > .v-list {
  box-shadow: none;
  background: $white;
}
.dropdown-menu {
  min-width: 10rem;
  transform: translate3d(-84px, 3px, 0px) !important;
  border: 1px solid $gray-300;
  .v-list-item {
    padding: 0;
    min-height: 0;
    height: fit-content;
  }
  .v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
    padding-inline-start: 0;
    padding-inline-end: 0;
  }
  .v-list-item-title:active {
    background-color: $base-blue;
    color: $white;
  }
  .v-list-item-title {
    padding: 4px 10px;
    width: 100%;
    &:hover {
      background-color: $gray-300;
    }
  }
}
</style>
